// 列表图片处理
export function productImg (url) {
  if (url.indexOf('http') < 0) {
    if (url.split(',')[0].indexOf('newImage/ad') !== -1) {
      url = this.newImgUrl + url.split(',')[0].replace('.png', '_750.png').replace('.jpg', '_750.jpg').replace('.jpeg', '_750.jpeg')
    } else if (url.split(',')[0].indexOf('newImage/product') !== -1) {
      url = this.newImgUrl + url.split(',')[0].replace('.png', '_330x330.png').replace('.jpg', '_330x330.jpg').replace('.jpeg', '_330x330.jpeg')
    } else if (url.split(',')[0].indexOf('newImage/gift') !== -1) {
      url = this.newImgUrl + url.split(',')[0].replace('.png', '_240x240.png').replace('.jpg', '_240x240.jpg').replace('.jpeg', '_240x240.jpeg')
    } else if (url.split(',')[0].indexOf('newImage/article') !== -1) {
      url = this.newImgUrl + url.split(',')[0].replace('.png', '_750x750.png').replace('.jpg', '_750x750.jpg').replace('.jpeg', '_750x750.jpeg')
    } else if (url.split(',')[0].indexOf('/element') !== -1) {
      // url = this.toolImgUrl + url.split(',')[0].replace('.png', '_750x750.png').replace('.jpg', '_750x750.jpg').replace('.jpeg', '_750x750.jpeg')
      url = this.toolImgUrl + url.split(',')[0] + '?imageView2/w/750'
    } else {
      url = this.imgUrl + url.split(',')[0] + '?imageView2/w/750'
    }
  }
  return url
}

export function productReladImg (url) {
  if (url.split(',')[0].indexOf('newImage/ad') !== -1) {
    url = url.split(',')[0].replace('_750.png', '.png').replace('_750.jpg', '.jpg').replace('_750.jpeg', '.jpeg')
  } else if (url.split(',')[0].indexOf('newImage/product') !== -1) {
    url = url.split(',')[0].replace('_330x330.png', '.png').replace('_330x330.jpg', '.jpg').replace('_330x330.jpeg', '.jpeg')
  } else if (url.split(',')[0].indexOf('newImage/gift') !== -1) {
    url = url.split(',')[0].replace('_240x240.png', '.png').replace('_240x240.jpg', '.jpg').replace('_240x240.jpeg', '.jpeg')
  } else if (url.split(',')[0].indexOf('newImage/article') !== -1) {
    url = url.split(',')[0].replace('_750x750.png', '.png').replace('_750x750.jpg', '.jpg').replace('_750x750.jpeg', '.jpeg')
  }
  return url
}

// 拼贴详情图片处理
export function pintieImg (url) {
  if (url.split(',')[0].indexOf('newImage/article') !== -1) {
    url = this.newImgUrl + url.split(',')[0].replace('.png', '_480.png').replace('.jpg', '_480.jpg').replace('.jpeg', '_480.jpeg')
  } else if (url.split(',')[0].indexOf('newImage/ad') !== -1) {
    url = this.newImgUrl + url.split(',')[0].replace('.png', '_750.png').replace('.jpg', '_750.jpg').replace('.jpeg', '_750.jpeg')
  } else if (url.split(',')[0].indexOf('newImage/product') !== -1) {
    url = this.newImgUrl + url.split(',')[0].replace('.png', '_750x750.png').replace('.jpg', '_750x750.jpg').replace('.jpeg', '_750x750.jpeg')
  } else {
    url = this.imgUrl + url.split(',')[0] + '?imageView2/w/750'
  }
  return url
}

// 拼贴详情图片处理
export function checkZan (id) {
  let array = sessionStorage.getItem('hasZanList') ? sessionStorage.getItem('hasZanList').split(',') : []
  if (array.length === 0) {
    array.splice(array.length, 0, id)
  } else {
    if (array.every(val => val != id)) {
      array.splice(array.length, 0, id)
    } else {
      for (let i = 0, len = array.length; i < len; i++) {
        if (array[i] == id) {
          array.splice(i, 1)
          break
        }
      }
    }
  }
  sessionStorage.setItem('hasZanList', array)
  let time = parseInt(this.getAbsTime().getTime() / 1000)
  if (sessionStorage.getItem('hasZanListTime') && time - sessionStorage.getItem('hasZanListTime') > 600) {
    sessionStorage.removeItem('hasZanList')
    sessionStorage.removeItem('hasZanListTime')
  } else {
    if (!sessionStorage.getItem('hasZanListTime')) {
      sessionStorage.setItem('hasZanListTime', time)
    }
  }
}

export function checkZanList (list) {
  let array = sessionStorage.getItem('hasZanList') ? sessionStorage.getItem('hasZanList').split(',') : []
  if (array.length > 0) {
    for (let j = 0, len = list.length; j < len; j++) {
      for (let i in array) {
        if (list[j].id == array[i]) {
          list[j].likes = true
          list[j].likesNum++
        }
      }
    }
  }
  return list
}

export function headimg (url) {
  if (!url) {
    url = 'https://sami-1256315447.cos.ap-guangzhou.myqcloud.com/newImage/activity/202101/9820b239b0c3e3989a30de197e5c218.png'
  } else if (url.split(',')[0].indexOf('http') < 0) {
    url = this.newImgUrl + url + '?imageView2/5/w/79'
  }
  return url
}

export function getBrowserInterfaceSize () {
  var pageWidth = window.innerWidth
  var pageHeight = window.innerHeight
  if (typeof pageWidth !== 'number') {
    // 在标准模式下面
    if (document.compatMode === 'CSS1Compat') {
      pageWidth = document.documentElement.clientWidth
      pageHeight = document.documentElement.clientHeight
    } else {
      pageWidth = document.body.clientWidth
      pageHeight = window.body.clientHeight
    }
  }
  return {
    pageWidth: pageWidth,
    pageHeight: pageHeight
  }
}
// this.getBrowserFun.pageWidth/this.getBrowserFun.pageHeight



// WEBPACK FOOTER //
// ./src/utils/common.js